import { render } from "./onboarding.vue?vue&type=template&id=c0c440ce&scoped=true&ts=true"
import script from "./onboarding.vue?vue&type=script&lang=ts"
export * from "./onboarding.vue?vue&type=script&lang=ts"

import "./onboarding.vue?vue&type=style&index=0&id=c0c440ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0c440ce"]])

export default __exports__